import { Link } from 'react-router-dom'

export const Error = () => (<div id='error'>
    <h1>Page not found.</h1>
    <p>You can visit our <Link to='/'>main page</Link> to view current information.</p>
</div>)